import { InjectionToken, container, injectable } from "tsyringe";

export const TOKEN_ITransientLocator = Symbol('ITransientLocator');

/**
 * Use this to get an instance of any non-singleton service or store
 */
export interface ITransientLocator {
    /**
     * Spin up a transient instance using DI
     */
    resolve<T>(token: InjectionToken<T>): T;
}

@injectable()
export class TransientLocator implements ITransientLocator {
    public resolve<T>(token: InjectionToken<T>): T {
        return container.resolve(token);
    }
}